import { useLocation } from 'react-router-dom';
import { hr_HR } from './constants';

export function UseQuery() {
	return new URLSearchParams(useLocation().search);
}

export const getLanguage = () => localStorage.getItem('i18nextLng') || hr_HR;